import React from 'react';
import moment from 'moment';
import 'moment-timezone';
import { uuid } from 'uuidv4'; // Global States for faster scheduling

import { useStore } from "../../contexts/store";
import { updateScheduleByEplId } from "../../api"; // Files for this component

import days from "./helpers/days";
import RenderAvailability from "./components/RenderAvailability";
import "./style.css";

const OverviewAvailabilities = ({
  growlStore
}) => {
  const {
    state,
    dispatch
  } = useStore();
  const {
    schedule,
    selectedDate,
    clientTimezone,
    expertTimezone,
    showTimeslots,
    availabilityStore_imp
  } = state;

  const handleAddAvailability = () => {
    dispatch({
      type: 'UPDATE',
      payload: {
        selectedDate: selectedDate,
        readOnly: false,
        currentPath: 'calendarview'
      }
    });
  };

  const add = () => {
    dispatch({
      type: 'UPDATE',
      payload: {
        selectedDate: moment(selectedDate).add(1, 'days').toDate().getTime(),
        dayToRender: moment(selectedDate).add(1, 'days')
      }
    });
  };

  const substract = () => {
    if (moment().format('YYYYMMDD') >= moment(selectedDate).format('YYYYMMDD')) {
      return;
    } else {
      dispatch({
        type: 'UPDATE',
        payload: {
          selectedDate: moment(selectedDate).subtract(1, 'days').toDate().getTime(),
          dayToRender: moment(selectedDate).subtract(1, 'days')
        }
      });
    }
  };

  const onRemove = async timeslot => {
    if (timeslot.raw.group && timeslot.raw.group.length > 0) {
      const data = timeslot.type === 'client' ? {
        clientAvailabilitiesToRemove: timeslot.raw.group
      } : {
        expertAvailabilitiesToRemove: timeslot.raw.group
      };

      try {
        await updateScheduleByEplId(availabilityStore_imp.epl.id, data); // TODO: avoid using querySelector

        const slot = document.querySelector(`#A${timeslot.id}`);
        slot.classList.add('deleteSlot');
        slot.addEventListener('animationend', e => {
          const result = [...schedule.availabilities].filter(avb => avb.id !== timeslot.id);
          dispatch({
            type: 'SETSCHEDULE',
            payload: {
              schedule: { ...schedule,
                availabilities: result
              }
            }
          });
        });
      } catch (error) {
        growlStore.showError(error.response.data.message);
      }

      return;
    }

    const slot = document.querySelector(`#A${timeslot.id}`);
    slot.classList.add('deleteSlot');
    slot.addEventListener('animationend', e => {
      const result = [...schedule.availabilities].filter(avb => avb.id !== timeslot.id);
      dispatch({
        type: 'SETSCHEDULE',
        payload: {
          schedule: { ...schedule,
            availabilities: result
          }
        }
      });
    });
  };

  const onEdit = timeslot => {
    dispatch({
      type: 'UPDATE',
      payload: {
        readOnly: false,
        selectedDate: new Date(timeslot.time.start).getTime(),
        dayToRender: moment(timeslot.time.start),
        currentPath: 'calendarview'
      }
    });
  };

  const onToggle = () => {
    dispatch({
      type: 'UPDATE',
      payload: {
        disableAddAnotherExpert: true,
        showTimeslots: !showTimeslots
      }
    });
  };

  function Toggle({
    showTimeslots = null
  } = {}) {
    if (showTimeslots) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, "Hide availabile timeslots ", /*#__PURE__*/React.createElement("i", {
        className: "arrow up"
      }), ' ');
    }

    return /*#__PURE__*/React.createElement(React.Fragment, null, "Show availabile timeslots ", /*#__PURE__*/React.createElement("i", {
      className: "arrow down"
    }), ' ');
  }

  const todayAvailable = days(schedule).filter(day => moment(day.key).format('DDMMYYYY') === moment(selectedDate).format('DDMMYYYY'));

  if (!todayAvailable.length) {
    return null;
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h4", {
    className: "toggleCalendarButton",
    onClick: onToggle
  }, /*#__PURE__*/React.createElement(Toggle, {
    showTimeslots: showTimeslots
  })), showTimeslots && /*#__PURE__*/React.createElement("div", {
    className: "availabilityContainer"
  }, /*#__PURE__*/React.createElement("div", {
    title: "Add Availability",
    className: "addAvailability",
    onClick: () => handleAddAvailability()
  }, "+"), /*#__PURE__*/React.createElement("div", {
    id: "dateContainer"
  }, /*#__PURE__*/React.createElement("span", {
    onClick: () => substract(),
    title: "Previous"
  }, ' ', "\u2039", ' '), /*#__PURE__*/React.createElement("p", {
    className: "selectedDate"
  }, moment(selectedDate).format('LL')), /*#__PURE__*/React.createElement("span", {
    onClick: () => add(),
    title: "Next"
  }, ' ', "\u203A", ' ')), /*#__PURE__*/React.createElement("div", {
    className: "overview-content-availability-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "availability client"
  }, /*#__PURE__*/React.createElement("h5", null, "CLIENT(", clientTimezone, ")")), /*#__PURE__*/React.createElement("div", {
    className: "availability expert"
  }, /*#__PURE__*/React.createElement("h5", null, "EXPERT (", moment(selectedDate).tz(expertTimezone.name).format('Z'), ")"))), /*#__PURE__*/React.createElement("div", {
    className: "overview-content-availability-wrapper column"
  }, todayAvailable.map(day => {
    return /*#__PURE__*/React.createElement("div", {
      className: "flex",
      key: uuid()
    }, day.render, /*#__PURE__*/React.createElement("div", {
      className: "availability client"
    }, /*#__PURE__*/React.createElement(RenderAvailability, {
      day: day,
      type: 'client',
      onRemove: onRemove,
      onEdit: onEdit,
      schedule: schedule
    })), /*#__PURE__*/React.createElement("div", {
      className: "availability expert"
    }, /*#__PURE__*/React.createElement(RenderAvailability, {
      day: day,
      type: 'expert',
      onRemove: onRemove,
      onEdit: onEdit,
      schedule: schedule
    })));
  }))));
};

export default OverviewAvailabilities;